"use strict";
/****************************************************
 * Audit Information Platform Component
 * 提供加解密算法支持
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
var CryptoJS = require("crypto-js");
var LZUTF8 = require("lzutf8");
var KEY_ARRAY = [
    40, 5, 46, 43, 40, 5, 46, 4, 41, 4, 4, 51, 41, 54, 16, 35, 12, 53, 57, 45,
];
var CHARS_TABLE = "abcdefABCDjkEF6789=NOPQWXtuvwxyz01YZghilmnopqGHIJKLMrs2RSTUV345";
/**
 * LZ 压缩 UTF8 编码
 */
var LZC = LZUTF8.compress;
/**
 * LZ 解压缩 UTF8 编码
 */
var LZD = LZUTF8.decompress;
var CJ = CryptoJS;
var CJAE = CryptoJS.AES.encrypt;
var CJAD = CryptoJS.AES.decrypt;
var CJ_UTF8 = CryptoJS.enc.Utf8;
var genKey = function (k) {
    var cs = [];
    var len = CHARS_TABLE.length;
    for (var i = 0, l = k.length; i < l; i++) {
        cs.push(CHARS_TABLE[len - k[i]]);
    }
    return cs.join("");
};
var OUTPUT_PROP = {
    outputEncoding: 'Base64'
};
var INPUT_PROP = {
    inputEncoding: "Base64",
};
function _encOrDecHandler(str, encFlag) {
    if (encFlag) {
        return CJAE(JSON.stringify(str), LZD(genKey(KEY_ARRAY), INPUT_PROP)).toString();
    }
    else {
        var bytes = CJAD(str, LZD(genKey(KEY_ARRAY), INPUT_PROP));
        return bytes.toString(CJ_UTF8);
    }
}
/**
 * 加密解密函数对象
 */
var Codec = {
    /**
     * 对字符串数据进行加密
     * @function
     *
     * @param {string} str 要加密的字符串
     * @param {string} token 可以理解为钥匙
     * @returns {string} 加密后的字符串
     */
    enc: function (str, token) {
        if (token) {
            var sKey = CryptoJS.enc.Utf8.parse(token);
            var sContent = CryptoJS.enc.Utf8.parse(str);
            var encrypted = CryptoJS.AES.encrypt(sContent, sKey, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            });
            return encrypted.toString();
        }
        else
            return _encOrDecHandler(str, true);
    },
    /**
     * 对字符串数据进行解密
     * @function
     *
     * @param {string} str 要解密的字符串
     * @param {string} token 可以理解为钥匙
     * @returns {string} 解密后的字符串
     */
    dec: function (str, token) {
        if (token) {
            var sKey = CryptoJS.enc.Utf8.parse(token);
            var decrypt = CryptoJS.AES.decrypt(str, sKey, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            });
            return CryptoJS.enc.Utf8.stringify(decrypt).toString();
        }
        else
            return _encOrDecHandler(str, false);
    },
    /**
     * 对字符串数据进行LZ 压缩
     * @function
     *
     * @param {string} input 要压缩的字符串
     * @param {LZUTF8.CompressionOptions} options 请使用: Codec.OUTPUT_PROP(string)
     * @returns {string} 压缩后的字符串
     */
    LZC: LZC,
    /**
     * 对字符串数据进行LZ 解压缩
     * @function
     *
     * @param {string} input 要解压缩的字符串
     * @param {LZUTF8.DecompressionOptions } options 请使用 Codec.INPUT_PROP(base64)
     * @returns {string} 解压缩后的字符串
     */
    LZD: LZD,
    INPUT_PROP: INPUT_PROP,
    OUTPUT_PROP: OUTPUT_PROP,
    COM_PROP: OUTPUT_PROP,
    DECOM_PROP: INPUT_PROP,
};
exports.default = Codec;
